export default "__VITE_ASSET__BxKTt13r__"